import React, { useContext } from 'react';
import Claims from './Claims';
import { DashboardContext } from 'context/DashboardContext';
import { api_srv } from '../../services';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import Loader from 'components/widgets/loader';
import styled from 'styled-components';
import ApexChart from 'react-apexcharts';

	const DashboardContainer = styled.div`
	padding: 24px;
	max-width: 1100px;
	margin: 0 auto;
	font-family: -apple-system, BlinkMacacSystemFont, 'Segoe UI', Roboto, sans-serif;
	`;

	const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	gap: 24px;
	margin-bottom: 32px;
	`;

	const Card = styled.div`
	background: white;
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0,0,0,0.08);
	padding: 24px;
	border: 1px solid #f0f0f0;
	`;

	const CardTitle = styled.h2`
	margin: 0 0 16px 0;
	font-size: 1.4rem;
	color: #1a1a1a;
	font-weight: 600;
	`;

	const BigNumber = styled.div`
	font-size: 3.2rem;
	font-weight: 700;
	color: #2c3e50;
	margin: 8px 0;
	`;

	const Subtitle = styled.div`
	color: #7f8c8d;
	font-size: 1.1rem;
	`;

	const TimePeriods = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	`;

	const PeriodItem = styled.div`
	background: ${props => props.active ? '#e8f4ff' : '#f8f9fa'};
	border-radius: 10px;
	padding: 16px 20px;
	border-left: 5px solid ${props => props.active ? '#3498db' : '#bdc3c7'};
	`;

	const PeriodLabel = styled.div`
	color: #7f8c8d;
	font-size: 0.95rem;
	margin-bottom: 4px;
	`;

	const PeriodValue = styled.div`
	font-size: 1.9rem;
	font-weight: 700;
	color: #2c3e50;
	`;

	const ChartCard = styled(Card)`
	grid-column: span 2;
	`;

	const StatusGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-top: 32px;
	`;

	const StatusCard = styled.div`
	background: white;
	border-radius: 12px;
	box-shadow: 0 4px 12px rgba(0,0,0,0.08);
	padding: 28px 24px;
	text-align: center;
	border: 1px solid #f0f0f0;
	`;

	const StatusIcon = styled.div`
	font-size: 3.5rem;
	margin-bottom: 16px;
	color: ${props => props.color || '#3498db'};
	`;

	const StatusTitle = styled.h3`
	font-size: 1.3rem;
	margin: 8px 0;
	color: #2c3e50;
	`;

	const StatusDescription = styled.p`
	color: #7f8c8d;
	font-size: 0.95rem;
	line-height: 1.4;
	`;

const ClaimsContainer = () => {
	const barChartOptions = {
		chart: {
		type: 'bar',
		height: 320,
		toolbar: { show: false },
		},
		plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '55%',
			endingShape: 'rounded',
		},
		},
		dataLabels: { enabled: false },
		stroke: { show: true, width: 2, colors: ['transparent'] },
		xaxis: {
		categories: ['Motor', 'Health', 'Havoc'],
		},
		yaxis: {
		title: {
			text: 'Number of Claims',
		},
		min: 0,
		forceNiceScale: true,
		},
		fill: {
		opacity: 1,
		colors: ['#3498db', '#2ecc71', '#e74c3c'],
		},
		tooltip: {
		y: {
			formatter: val => `${val} claims`,
		},
		},
	};

  const barChartSeries = [
    {
      name: 'Claims',
      data: [140, 280, 180], // ← replace with your real numbers
    },
  ];

	return (
<DashboardContainer>
      <Grid>
        {/* Total Claims Card */}
        <Card>
          <CardTitle>Total Claims</CardTitle>
          <BigNumber>20</BigNumber>
          <Subtitle>Overall registered claims</Subtitle>

          <TimePeriods>
            <PeriodItem active>
              <PeriodLabel>This Year</PeriodLabel>
              <PeriodValue>10</PeriodValue>
            </PeriodItem>
            <PeriodItem>
              <PeriodLabel>This Month</PeriodLabel>
              <PeriodValue>5</PeriodValue>
            </PeriodItem>
            <PeriodItem>
              <PeriodLabel>This Week</PeriodLabel>
              <PeriodValue>3</PeriodValue>
            </PeriodItem>
          </TimePeriods>
        </Card>

        {/* Bar Chart */}
        <ChartCard>
          <CardTitle>Claims by Category</CardTitle>
          <ApexChart
            options={barChartOptions}
            series={barChartSeries}
            type="bar"
            height={320}
          />
        </ChartCard>
      </Grid>

      {/* Pending / Processing Status */}
      <StatusGrid>
        <StatusCard>
          <StatusIcon color="#f39c12">⏳</StatusIcon>
          <StatusTitle>Pending</StatusTitle>
          <StatusDescription>
            Claims awaiting to be submitted<br />
            to Underwriting
          </StatusDescription>
        </StatusCard>

        <StatusCard>
          <StatusIcon color="#27ae60">⚙️</StatusIcon>
          <StatusTitle>Processing</StatusTitle>
          <StatusDescription>
            Claims being processed<br />
            by Underwriting
          </StatusDescription>
        </StatusCard>
      </StatusGrid>
    </DashboardContainer>
	);
};

export default ClaimsContainer;
